import { Navigate } from 'react-router';

import { UsersBaseRoute } from './users/Routes';

export const UserManagementHome = () => <Navigate to={UsersBaseRoute} />;
